import styled from 'styled-components';
import HowItWorksInfoSection from './HowItWorksInfoSection';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';
import HeaderSection from '../shared/HeaderSection';

const HiddenH1 = styled.h1`
  position:absolute;
  left:-10000px;
  top:auto;
  width:1px;
  height:1px;
  overflow:hidden;
`;

const HowItWorksPageContent = (props) => {
  const {
    howItWorksPageData = {},
    pageTitle = '',
  } = props;

  const {
    headerSection = {},
    infoSections = [],
  } = howItWorksPageData;

  const createInfoSections = (isMobile) => {
    return infoSections.map((section, index) => {
      return (
        <HowItWorksInfoSection
          key={`how-it-works-info-section-${section.id}`}
          sectionData={section}
          backgroundColor={(
            section.backgroundColor
            || (index % 2 === 0 ? (p) => p.theme.c.bg.primary : (p) => p.theme.c.bg.secondary)
          )}
          isMobile={isMobile} />
      );
    });
  };

  const desktopPage = (
    <div>
      <HiddenH1>{ pageTitle }</HiddenH1>
      <HeaderSection headerSectionData={headerSection} />
      { createInfoSections(false) }
    </div>
  );

  const mobilePage = (
    <div>
      <HiddenH1>{ pageTitle }</HiddenH1>
      <HeaderSection isMobile headerSectionData={headerSection} />
      { createInfoSections(true) }
    </div>
  );

  const renderComp = (
    <MediaQueryHelper
      desktopChildren={desktopPage}
      mobileChildren={mobilePage}
      />
  );

  return renderComp;
};

export default HowItWorksPageContent;
